import { Analytics } from '@cobliteam/analytics';
import { useTranslation } from '@cobliteam/i18n';
import { startTransition, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useAIAssistant } from '../../store';
import AIBetaFlag from '../AIBetaFlag';
import AIButton from '../AIButton';

const AI_ROUTE_PREFIX = '/ai';

const AIAssistantCenterFloatButton = () => {
  const { t } = useTranslation('ai');
  const { openAISidepanel, isAISidepanelOpen } = useAIAssistant();
  const { pathname } = useLocation();

  const handleClick = useCallback(() => {
    Analytics.track('AI - Float Button - Clicked');
    startTransition(() => {
      openAISidepanel();
    });
  }, [openAISidepanel]);

  if (pathname.startsWith(AI_ROUTE_PREFIX)) return null;
  if (isAISidepanelOpen) return null;

  return (
    <div className='fixed inset-x-0 bottom-7 z-[60] flex justify-center px-2'>
      <AIButton
        onClick={handleClick}
        isSelected={false}
        label={
          <>
            {t('assistant_float.label')}
            <AIBetaFlag variant='light' className='ml-1.5' />
          </>
        }
        variant='solid'
        shape='cta'
      />
    </div>
  );
};

export default AIAssistantCenterFloatButton;
